
export default {
  namespaced: true,

  state: {
    title: null,
    activeMenu: null,
    currentRoute: null,
    prevRoute: null,
    downloadButtonVisible: true,
    floatMenusVisible: false,
    arrowLeftVisible: false,
    arrowLeftPreventDefault: false,
    backbuttonEventGenerator: false
  },

  actions: {},

  mutations: {
    setArrowLeftVisible(state, value) {
      state.arrowLeftVisible = value;
    },

    setArrowLeftPreventDefault(state, value) {
      state.arrowLeftPreventDefault = value;
    },

    setShowDownloadButton(state, value) {
      state.downloadButtonVisible = value;
    },

    setLayoutTitle(state, value) {
      state.title = value;
    },

    setActiveMenu(state, value) {
      state.activeMenu = value;
    },

    setCurrentRoute(state, value) {
      state.currentRoute = value;
    },

    setPrevRoute(state, prevRoute) {
      if (prevRoute.path !== '/') {
        state.prevRoute = prevRoute;
      }
    },

    setFloatMenusVisible(state, value) {
      state.floatMenusVisible = value;
    },

    emitBackButtonClickEvent(state) {
      state.backbuttonEventGenerator = !state.backbuttonEventGenerator
    },
  },

  getters: {
    title: state => state.title,
    activeMenu: state => state.activeMenu,
    currentRoute: state => state.currentRoute,
    prevRoute: state => state.prevRoute,
    downloadButtonVisible: state => state.downloadButtonVisible,
    floatMenusVisible: state => state.floatMenusVisible,
    arrowLeftVisible: state => state.arrowLeftVisible,
    arrowLeftPreventDefault: state => state.arrowLeftPreventDefault,
    backbuttonEventGenerator: state => state.backbuttonEventGenerator
  }
};
